import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post('http://localhost:4500/api/auth/login', {
        email,
        password
      });

      if (response.data.success && response.data.user.admin === 1) {
        // Store token in localStorage for website
        localStorage.setItem('adminToken', response.data.token);
        localStorage.setItem('adminUser', JSON.stringify(response.data.user));
        
        // Redirect to admin panel
        navigate('/admin');
      } else {
        setError('❌ Nur Admin-Accounts haben Zugriff auf dieses Panel');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Login fehlgeschlagen');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 text-white flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-slate-800/50 border border-purple-500/30 rounded-lg p-8">
          <h1 className="text-3xl font-bold mb-2 text-center">👑 Admin Panel</h1>
          <p className="text-slate-400 text-center mb-6">Authentifizierung erforderlich</p>

          <form onSubmit={handleLogin}>
            {error && (
              <div className="bg-red-900/30 border border-red-500 text-red-200 p-3 rounded-lg mb-4 text-sm">
                {error}
              </div>
            )}

            <div className="mb-4">
              <label className="block text-sm font-bold mb-2">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@timelock.de"
                className="w-full bg-slate-700/50 border border-purple-500/30 rounded-lg px-4 py-2 text-white placeholder-slate-400 focus:border-purple-500 focus:outline-none"
                required
              />
            </div>

            <div className="mb-6">
              <label className="block text-sm font-bold mb-2">Passwort</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="w-full bg-slate-700/50 border border-purple-500/30 rounded-lg px-4 py-2 text-white placeholder-slate-400 focus:border-purple-500 focus:outline-none"
                required
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 disabled:opacity-50 text-white font-bold py-3 rounded-lg transition-all"
            >
              {loading ? 'Wird geladen...' : 'Login'}
            </button>
          </form>

          <div className="mt-6 pt-6 border-t border-purple-500/30 text-center">
            <p className="text-xs text-slate-400">
              Standard Admin:<br/>
              Email: <code className="text-purple-300">admin@timelock.de</code><br/>
              Password: <code className="text-purple-300">0815</code>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
